import React from 'react';
import { ZipCodeStore } from '@common/stores';

export const ZipCodeStoreContext = React.createContext<ZipCodeStore | null>(
  null,
);

export const ZipCodeStoreProvider = ({
  children,
}: React.PropsWithChildren<{}>) => {
  const zipCodeStore = React.useMemo(() => {
    return new ZipCodeStore();
  }, []);

  return (
    <ZipCodeStoreContext.Provider value={zipCodeStore}>
      {children}
    </ZipCodeStoreContext.Provider>
  );
};

export const useZipCodeStore = () => {
  const store = React.useContext(ZipCodeStoreContext);
  if (!store)
    throw new Error(
      'useZipCodeStore must be used within a ZipCodeStoreProvider',
    );
  return store;
};
